import get from 'lodash/get';
import indexOf from 'lodash/indexOf';

const alphabetic = (offer1, offer2) => {
  const merchantName1 = get(offer1, 'rclonMerchantName');
  const merchantName2 = get(offer2, 'rclonMerchantName');

  if (!merchantName1) {
    return -1;
  }

  if (!merchantName2) {
    return 1;
  }
  const nameA = merchantName1.toUpperCase();
  const nameB = merchantName2.toUpperCase();

  if (nameA < nameB) {
    return -1;
  }

  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

const soonestExpiredSort = (offer1, offer2) => {
  const daysA = get(offer1, 'daysToExpire');
  const daysB = get(offer2, 'daysToExpire');

  if (daysA !== undefined && daysB !== undefined && daysA < daysB) {
    return -1;
  }

  if (daysA !== undefined && daysB !== undefined && daysA > daysB) {
    return 1;
  }

  return alphabetic(offer1, offer2);
};

export const sortAlphabetical = offers => offers.sort(alphabetic);

export const sortLinked = offers => offers.sort(
  (offer1, offer2) => {
    const offerLinked1 = get(offer1, 'linked');
    const offerLinked2 = get(offer2, 'linked');

    if (offerLinked2 && !offerLinked1) {
      return 1;
    }
    if (offerLinked1 && !offerLinked2) {
      return -1;
    }

    return soonestExpiredSort(offer1, offer2);
  },
);

export const sortEarnRate = offers => offers.sort(
  (offer1, offer2) => parseFloat(offer2.displayRate) - parseFloat(offer1.displayRate),
);

export const sortByLocation = (offers, locations) => {
  const locationsIds = locations.map(a => a.carteraMerchantId);
  const uniqueLocationIds = [...new Set(locationsIds)].reverse();

  offers.sort((offer1, offer2) => {
    const indexA = indexOf(uniqueLocationIds, offer1.carteraMerchantId);
    const indexB = indexOf(uniqueLocationIds, offer2.carteraMerchantId);

    if (indexA < indexB) {
      return 1;
    }

    if (indexA > indexB) {
      return -1;
    }

    return 0;
  });

  return offers;
};
